import { IMessage, IRequestApartments, IFileKey, IRequestMaintenances, IShowApartments } from '../../interfaces'
import api from '../api/server'

export default class PageService {
    public static async getRequestApartments(): Promise<IRequestApartments[]> {
        return (await api.get<IRequestApartments[]>('/real-estates/apartments/files')).data
    }

    public static async getFileUrl(id: number): Promise<IFileKey> {
        return (await api.get<IFileKey>(`/real-estates/apartments/files/${id}/url`)).data
    }

    public static async getShowApartments(): Promise<IShowApartments[]> {
        return (await api.get<IShowApartments[]>('/real-estates/apartments/user-apartments')).data
    }

    public static async postMaintenances(data: IRequestMaintenances): Promise<IMessage> {
        return (await api.post<IMessage>('/maintenances/request', data)).data
    }
}
